import propagate from './propagate';
import returnUrl from './returnUrl';
import { compose } from 'redux';
export default {
  enhance: compose(returnUrl, propagate)
};